import { Component, OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { DarkmodeService } from '../../_provider/darkmode.service';
import { ZeitenService } from '../../_provider/zeiten.service';
import { TimeOverviewBasePage } from './time-overview-base/time-overview-base.page';

@Component({
    selector: 'app-time-overview',
    templateUrl: './time-overview.component.html',
    styleUrls: ['./time-overview.component.scss'],
    standalone: false
})
export class TimeOverviewComponent implements OnInit {


  public now: Date = new Date()

  private timerSub: Subscription

  constructor(
    public timeSrv: ZeitenService,
    public darkmode: DarkmodeService,
    private feedback: FeedbackService,
    private modalCtrl: ModalController,
  ) { 
    this.timerSub = this.timeSrv.timer().subscribe(()=>{
      this.now = new Date()
    })
  } 

  ngOnInit() {


  }

  ngOnDestroy(){
    this.timerSub.unsubscribe()
  }

  public async openModel(){
    await this.feedback.openModal(TimeOverviewBasePage)
  }

}
